import { createStructuredSelector } from 'reselect';
import { selectIsLeadManagement, selectPrimary, selectSecondary, selectSelectedAddress, selectSuggestions } from '../AddressValidation/selector';

export const mapStateToProps = createStructuredSelector({
    suggestions: selectSuggestions,
    primary: selectPrimary,
    secondary: selectSecondary,
    isLeadManagement: selectIsLeadManagement,
    selectedAddress: selectSelectedAddress,
});
